import { breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

import {
  BaseInfoWrapper,
  BasePillLabel,
  BaseStyledDropdownMenu,
} from '../shared-attachment-pill/SharedAttachmentPill.styles';

export const StyledDropdownMenu = styled(BaseStyledDropdownMenu)`
  @media ${breakpoints['max-xs']} {
    width: 250px;
    min-width: 250px;
  }
`;

export const InfoWrapper = styled(BaseInfoWrapper)``;
export const PillLabel = styled(BasePillLabel)``;
